/* eslint-disable prettier/prettier */
import { MyThunkResult } from 'store';

import { CostCenter } from 'models/costCenter';
import { CostCenterReportProducts, CostCenterReportRequest, CostCenterReportResponse } from 'models/costCenterReport';
import { Response } from 'models/response';

import {
  doLoadCostCenterList,
  doCreateCostCenter,
  doUpdateCostCenterCode,
  doLoadCostCenterRequest,
} from '../action-creators/costCenter';
import { profile, axiosConfig, travel } from '../api';

interface CostCenterResponse {
  data: CostCenter[];
}

export const fetchCostCenterList = (): MyThunkResult<Promise<void>> => (dispatch) =>
  profile.get<CostCenterResponse>('/CostCenter/GetAll', axiosConfig).then((response) => {
    dispatch(doLoadCostCenterRequest);
    const { data } = response.data;
    dispatch(doLoadCostCenterList(data as CostCenter[]));
  });

export const fetchAllCostCenterListActive = (): MyThunkResult<Promise<void>> => (dispatch) =>
  profile.get<CostCenterResponse>('/CostCenter/GetAllUsersActive', axiosConfig).then((response) => {
    dispatch(doLoadCostCenterRequest);
    const { data } = response.data;
    dispatch(doLoadCostCenterList(data as CostCenter[]));
  });

export const saveCostCenter = (costCenter: CostCenter): MyThunkResult<Promise<void>> => (dispatch) => {
  if (costCenter.id) {
    return profile
      .put(`/CostCenter/${costCenter.id}`, {
        ...costCenter,
      })
      .then((response) => {
        dispatch(doUpdateCostCenterCode(response.data.data));
      });
  }
  return profile
    .post('/CostCenter', {
      ...costCenter,
    })
    .then((response) => {
      dispatch(doCreateCostCenter(response.data.data));
    });
};

export const fetchCostCenter = async (costCenterId: string) =>
  profile.get<Response<CostCenter>>(`/CostCenter/${costCenterId}`, axiosConfig);

export const fetchCostCenterListService = async () =>
  profile.get<Response<CostCenter[]>>('/CostCenter/GetAll', axiosConfig);

export const fetchCostCenterReport = async (filters: CostCenterReportRequest) => {
  const startDateFilter = filters?.initDate ? `startDate=${filters.initDate}` : '';

  const endDateFilter = filters?.endDate ? `endDate=${filters.endDate}` : '';

  const productType = filters?.tripType !== CostCenterReportProducts.All ? `&productType=${filters.tripType}` : '';

  return travel
    .get<any>(
      `/Travels/CostCenterTravelReport/Email/${filters.costCenterId}/?${startDateFilter}&${endDateFilter}${productType}`,
      axiosConfig,
    )
    .then((response) => { })
    .catch((error) => {
      throw error;
    });
};

export const fetchCostCenterReportView = async (filters: CostCenterReportRequest) => {
  const startDateFilter = filters?.initDate ? `startDate=${filters.initDate}` : '';

  const endDateFilter = filters?.endDate ? `endDate=${filters.endDate}` : '';

  const userGroupId = filters?.userGroupId ? `&userGroupId=${filters.userGroupId}` : '';

  const productType = filters?.tripType !== CostCenterReportProducts.All ? `&productType=${filters.tripType}` : '';

  return travel
    .get<Response<CostCenterReportResponse>>(
      `/Travels/CostCenterTravelReport/View/${filters.costCenterId}/?${startDateFilter}&${endDateFilter}${productType}${userGroupId}`,
      axiosConfig,
    );
};
